/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for updating a meta MCP membership.
 */
export type UpdateMetaMcpMemberForm = {
  /**
   * The ID of the membership to update
   */
  id: string;
  /**
   * The position of the member in the ordered member set
   */
  sortOrder: number;
};

/** @internal */
export type UpdateMetaMcpMemberForm$Outbound = {
  id: string;
  sort_order: number;
};

/** @internal */
export const UpdateMetaMcpMemberForm$outboundSchema: z.ZodMiniType<
  UpdateMetaMcpMemberForm$Outbound,
  UpdateMetaMcpMemberForm
> = z.pipe(
  z.object({
    id: z.string(),
    sortOrder: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      sortOrder: "sort_order",
    });
  }),
);

export function updateMetaMcpMemberFormToJSON(
  updateMetaMcpMemberForm: UpdateMetaMcpMemberForm,
): string {
  return JSON.stringify(
    UpdateMetaMcpMemberForm$outboundSchema.parse(updateMetaMcpMemberForm),
  );
}
